
;(function (window, APP, Backbone, Marionette, $, _) {
	'use strict';

	var View = APP.module('View');

	View.TippingLeaguesManageControls = View.TippingLeaguesManageControls.extend({
		template: JST.ExtendTippingLeaguesManageControlsAboutPageAflClubs,
		ui: {
			league_select   : '.js-league-select',
			round_select    : '.js-league-rounds-select',
			share_btn       : '.js-share',
			countdown       : '.js-countdown',
			canvas          : '.circle_animation'
		},
		events: {
			'change @ui.league_select'  : 'changeLeague',
			'click @ui.share_btn'       : 'shareInvite',
			'change @ui.round_select'   : 'changeRounds'
		},
		initListeners: function(){

			this.on('set:rounds:control', this.showRoundsControl);
			this.on('show:view:tips:btn', this.showViewTipsBtn);
			return this;
		},

		showRoundsControl: function(rounds){
			var rd_options = rounds.getCompleteAndPlayedRoundsOptions();

			this.model.set({
				rounds_options: rd_options
			});

			this.hidePreloader();
			return this.render();
		},

		setModelData: function() {

			this.model.set({
				league:  this.league.toJSON(),
				leagues: this.leagues.toJSON(),
				user_rank : this.ladder.get('user_rank')
			});
			this.hidePreloader();
			return this;
		},

		showViewTipsBtn: function(rounds){
			this.model.set({
				show_view_tips_btn: Boolean(~['complete', 'active'].indexOf(rounds.getLastGameRound('id').get('status')))
			});

			return this.render();
		},

		changeRounds: function(e){
			this.trigger('change:rounds:control', {round: +this.ui.round_select.val()});
		}

	});

}(window, APP, Backbone, Marionette, $, _));